<template>
  <div class="container-fluid mt-5">
    <div class="row">
      <div class="col-xl-12 order-xl-1">
        <card>
          <form @submit.prevent="handleSubmit">
          <div slot="header" class="row align-items-center">
            <div class="col-8">
              <h2 class="mb-0 ml-4">Adicionar novo Método de calculo</h2>
            </div>
            <div class="col-4 text-right"  v-if="!isInsideModal" >
              <base-button
                @click="goBack"
                type="button"
                class="btn btn-sm btn-primary"
                >Voltar para lista</base-button
              >
            </div>
          </div>
          <div class="card-body">
              
                </div>
                <div class="card-body">
                    <div class="card-subtitle mv-4 mt-4"><h3 class="border-bottom">Gerais</h3></div>
                
                    <div class="row">
                <div class="col-md-4">
        <base-input
        :tabindex="0"
        ref="nameInput"
        label="Nome"
        prepend-icon="fas fa-user"
        v-model="metodocalculo.name"
        
        
        />
        
        <validation-error :errors="apiValidationErrors.name" />
</div><div class="col-md-4">              
    <base-input label="Tipo de imóvel/Atividade" >
    <el-select
    name="imoveltipo"
    ref="imoveltipoInput"
    :tabindex="0"
    v-model="metodocalculo.imoveltipo.id"
    filterable
    prepend-icon="fas fa-user"
    placeholder="Selecione..."
    
    
    >
    <el-option
        v-for="single_imoveltipo in all_imoveltipos"
        :key="single_imoveltipo.id"
        :value="single_imoveltipo.id"
        :label="preferencia && preferencia.imoveltipo && single_imoveltipo.id === preferencia.imoveltipo.id ? `★ ${single_imoveltipo.name}` : single_imoveltipo.name"
        
    >
    </el-option>
    </el-select>
    </base-input>
    <validation-error :errors="apiValidationErrors.imoveltipo" />
    <div ref="display_imoveltipo"></div>
</div></div>
                    <div class="card-subtitle mv-4 mt-4"><h3 class="border-bottom">Fórmula para calculo de Coberturas</h3></div>
                <div class="row"><div class="col-md-4">
        <base-input
        :tabindex="0"
        ref="formulaincendioInput"
        label="Incêndio"
        prepend-icon="fa fa-fire"
        v-model="metodocalculo.formulaincendio"
        
        
        />
        
        <validation-error :errors="apiValidationErrors.formulaincendio" />
</div><div class="col-md-4">
        <base-input
        :tabindex="0"
        ref="formulacivilInput"
        label="Responsabilidade Civil"
        prepend-icon="fa fa-users"
        v-model="metodocalculo.formulacivil"
        
        
        />
        
        <validation-error :errors="apiValidationErrors.formulacivil" />
</div><div class="col-md-4">
        <base-input
        :tabindex="0"
        ref="formulaconteudoInput"
        label="Conteúdo"
        prepend-icon="ni ni-app"
        v-model="metodocalculo.formulaconteudo"
        
        
        />
        
        <validation-error :errors="apiValidationErrors.formulaconteudo" />
</div>
                        </div>
                    
                    <div class="row">
                <div class="col-md-4">
        <base-input
        :tabindex="0"
        ref="formulaeletricoInput"
        label="Danos Elétricos"
        prepend-icon="fa fa-bolt"
        v-model="metodocalculo.formulaeletrico"
        
        
        />
        
        <validation-error :errors="apiValidationErrors.formulaeletrico" />
</div><div class="col-md-4">
        <base-input
        :tabindex="0"
        ref="formulaimpactoInput"
        label="Impacto Veículos"
        prepend-icon="fa fa-car"
        v-model="metodocalculo.formulaimpacto"
        
        
        />
        
        <validation-error :errors="apiValidationErrors.formulaimpacto" />
</div><div class="col-md-4">
        <base-input
        :tabindex="0"
        ref="formulaaluguelInput"
        label="Perda Aluguel"
        prepend-icon="fa fa-home"
        v-model="metodocalculo.formulaaluguel"
        
        
        />
        
        <validation-error :errors="apiValidationErrors.formulaaluguel" />
</div>
                        </div>
                    
                    <div class="row">
                <div class="col-md-4">
        <base-input
        :tabindex="0"
        ref="formulavendavalInput"
        label="Vendaval"
        prepend-icon="fa fa-ellipsis-v"
        v-model="metodocalculo.formulavendaval"
        
        
        />
        
        <validation-error :errors="apiValidationErrors.formulavendaval" />
</div><div class="col-md-4">
        <base-input
        :tabindex="0"
        ref="formulatumultoInput"
        label="Tumulto"
        prepend-icon="ni ni-user-run"
        v-model="metodocalculo.formulatumulto"
        
        
        />
        
        <validation-error :errors="apiValidationErrors.formulatumulto" />
</div></div>
                    <div class="card-subtitle mv-4 mt-4"><h3 class="border-bottom"></h3></div>
                <div class="row">
            </div>
        
              
              <div class="my-4">
                <base-button
                  type="button"
                  class="btn btn-sm btn-primary"
                  native-type="submit"
                  :disabled="isSubmitting"
                >
                  Adicionar Método de calculo
                </base-button>
              </div>
          </div>
          </form>
        </card>
      </div>
    </div>
  
  </div>
</template>

<script>
import BaseInput from "@/components/Inputs/BaseInput.vue";
import BaseButton from "@/components/BaseButton.vue";
import BaseSlider from '@/components/BaseSlider';
import Modal from '@/components/Modal.vue';
import formMixin from "@/mixins/form-mixin";
import ValidationError from "@/components/ValidationError.vue";
import { Select, Option } from "element-ui";
import HtmlEditor from "@/components/Inputs/HtmlEditor";
import flatPicker from "vue-flatpickr-component";
import {Portuguese} from 'flatpickr/dist/l10n/pt.js';
flatpickr.localize(Portuguese);
import "flatpickr/dist/flatpickr.css";
import moment from "moment";
import { mask } from 'vue-the-mask';
import axios from 'axios';




export default {
  layout: "DashboardLayout",
  directives: { mask },

  components: {
    
    Modal,
    HtmlEditor,
    BaseInput,
    BaseButton,
    BaseSlider,
    ValidationError,
    flatPicker,
    [Select.name]: Select,
    [Option.name]: Option,
  },

  props: {
      isInsideModal: {
        type: Boolean,
        default: false,
      },
      insideModalOnSave: {
        type: String,
        required: false,
        default: null
      }
    },

  mixins: [formMixin],

  data() {
    return {
      isSubmitting: false,
      
      all_imoveltipos: [],
      
      
      
      metodocalculo: {
        type: "metodocalculos",
        
        name:'',
        formulaincendio:'',
        formulacivil:'',
        formulaconteudo:'',
        formulaeletrico:'',
        formulaimpacto:'',
        formulaaluguel:'',
        formulavendaval:'',
        formulatumulto:'',
        
            imoveltipo: {
                type: "imoveltipos",
                id: null
                },
        relationshipNames: ["imoveltipo"]
      },
      /*
        status: "published",
        is_on_homepage: false,
        date_at: new Date(),
        image: null,
        category: {
          type: "categories",
          id: null,
        },
        tags: [],
        relationshipNames: ["imoveltipo"]: ["category", "tags"],
        user: null,
      },*/
    };
  },
  computed: {
    
  },
  watch: {
    
  },
  created() {
    
    this.getImoveltipo();
  },

  methods: {
    
async getImoveltipo(idn = null) {
    try {
      //filter_route
      let params = {
        filter: {
            ...(this.imoveltipos_filter_itens ? this.imoveltipos_filter_itens : {}),
        },
      };
      //if(this.all_imoveltipos || Object.keys(this.all_imoveltipos).lenght == undefined){
        await this.$store.dispatch("imoveltipos/list", params);
        this.all_imoveltipos = await this.$store.getters["imoveltipos/dropdown"];
      //}
      

      if (this.all_imoveltipos && this.all_imoveltipos.length) {
       // this.metodocalculo.imoveltipo.id = this.all_imoveltipos[0].id;
        if(idn !== null){
            this.metodocalculo.imoveltipo.id = idn;            this.$refs.imoveltipoInput.$emit('change', this.metodocalculo.imoveltipo.id);
            
        }
      }
    } catch (error) {
      this.$notify({
        type: "danger",
        message: `Oops, something went wrong!`,
      });
      this.setApiValidation(error.response.data.errors);
    }
},
    
    /*
    async getTags() {
      try {
        await this.$store.dispatch("tags/list");
        this.all_tags = await this.$store.getters["tags/dropdown"];

        if (this.all_tags && this.all_tags.length) {
          this.tags.push(this.all_tags[0].id);
          this.item.tags = [];

          this.tags.forEach((tag) => {
            this.item.tags.push({
              id: tag,
              type: "tags",
            });
          });
        }
      } catch (error) {
        this.$notify({
          type: "danger",
          message: `Oops, something went wrong!`,
        });
        this.setApiValidation(error.response.data.errors);
      }
    },
*/
    //Formata numero para formato brasileiro
    numToBr(valor) {
        // Verifica se o valor termina com um ponto
        let sulfix='';
        if (valor.toString().endsWith('.')) {
          sulfix=',';
        }
        
      // Encontrar a quantidade de dígitos decimais no número original
      const numDecimais = (valor.toString().split('.')[1] || "").length;
      let valorFormatado = Number(valor).toLocaleString('pt-BR', {
        style: 'decimal',
        minimumFractionDigits: numDecimais,
        maximumFractionDigits: numDecimais
      });
      return (valorFormatado.toString()+sulfix);

    },
    //formata numero para formato americano
    numToUs(valorBrasileiro) {
        let valorFormatado = valorBrasileiro.replace(/\./g, '').replace(/,/g, '.');
        // Verifica se o último caractere é uma vírgula
        return (valorFormatado);
    },

    goBack() {
      this.$router.push({ name: "List Metodocalculos" });
    },
    removeImage() {
      this.image = null;
    },
    handleFunctionCall(payload) {
      const { functionName, args } = payload;
      if (functionName in this) {
        this[functionName](...args);
      } else {
        console.error(`Função ${functionName} não encontrada!`);
      }
    },

    async handleSubmit() {
      this.isSubmitting = true;
      await this.$store.dispatch("profile/me");
      this.user = await { ...this.$store.getters["profile/me"] };
      if (this.user.roles[0].name === "member") {
        this.$notify({
          type: "danger",
          message: "Oops, you are not authorized to do this action.",
        });
        return;
      }
      
      //this.metodocalculo.excerpt = this.metodocalculo.description;
      /**
      this.metodocalculo.date_at = moment(this.item.date_at).format("YYYY-MM-DD");
      this.metodocalculo.tags = [];
      this.tags.forEach((tag) => {
        this.item.tags.push({
          id: tag,
          type: "tags",
        });
      });
      */
      try {
        var dados_enviar=Object.assign({}, this.metodocalculo);
        
        if(dados_enviar.imoveltipo?.id==null){
          delete dados_enviar.imoveltipo;
        }
        




        if(dados_enviar.created_at){delete dados_enviar.created_at;}
        if(dados_enviar.updated_at){delete dados_enviar.updated_at;}
        if(dados_enviar.deleted_at){delete dados_enviar.deleted_at;}
        if(dados_enviar.tenants){delete dados_enviar.tenants;}

        if(!this.$route.params.id){
          //incluir novo registro
          delete dados_enviar.id;
          await this.$store.dispatch("metodocalculos/add", dados_enviar);
          this.metodocalculo = await this.$store.getters["metodocalculos/metodocalculo"];
        }else{
          //atualizar registro
          await this.$store.dispatch("metodocalculos/update", dados_enviar);
        }

        if (this.file) {
          await this.$store.dispatch("metodocalculos/upload", {
            metodocalculo: this.metodocalculo,
            image: this.file,
          });

          this.metodocalculo.image = await this.$store.getters["metodocalculos/url"];

          await this.$store.dispatch("metodocalculos/update", this.metodocalculo);
          this.metodocalculo = await this.$store.getters["metodocalculos/Metodocalculo"];
        }

        
        this.isSubmitting = false;
        this.$notify({
          type: "success",
          message: "Método de calculo Adicionado com sucesso.",
        });

        if(!this.isInsideModal){
          //retorna para a pagina anterior se não estiver dentro de um modal
          this.goBack();
        }else{
          //fecha modal
          this.$emit('close-modal');
          //executa função onsave (para recarregar elementos de um select por exemplo)
          if(this.insideModalOnSave!==null){
            this.$emit('callFunction', { functionName: this.insideModalOnSave, args: [this.metodocalculo.id] });
          }
        }


      } catch (error) {
        this.isSubmitting = false;
        this.$notify({
          type: "danger",
          message: "Oops, something went wrong!",
        });
        this.setApiValidation(error.response.data.errors);
        if (this.metodocalculo.id && !this.$route.params.id) {
          //executa apenas em tela de inclusão onde não tem id definido na tela... em tela de edição não esecuta
          await this.$store.dispatch("metodocalculos/destroy", this.metodocalculo.id);
        }

        this.metodocalculo.date_at = new Date();
      }
    },

    async onSelectFile(e) {
      let files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      this.createImage(files[0]);
    },

    createImage(file) {
      let reader = new FileReader();
      reader.onload = (e) => {
        this.image = e.target.result;
        this.file = file;
      };

      reader.readAsDataURL(file);
    },
  },
  
    mounted() {
    // Obtenha todos os elementos span dentro do elemento pai
    const spans = this.$el.querySelectorAll('span');

    // Remova a propriedade tabindex de todos os elementos span
    spans.forEach((span) => {
      span.removeAttribute('tabindex');
    });


    //verifica a aexistencia da funcão onmontedexe
    if (typeof this.onmountedexe === "function") {
      this.onmountedexe();
    }
  },
};
</script>
